import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/main.css'
import scrollReveal from './directives/scrollReveal'

const app = createApp(App)
app.directive('scroll-reveal', scrollReveal)
app.use(router).mount('#app')

// Scoped to /admin only -- lets the admin panel be installed as a desktop
// app (Chrome/Edge "Install" icon) without making the public site
// installable. See public/admin-manifest.json's "scope" and sw-admin.js.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-admin.js', { scope: '/admin/' }).catch(() => {
      // Installability is a nice-to-have; ignore registration failures.
    })
  })
}
